<template>
  <div class="fixed inset-0 bg-gradient-to-b from-[#142a4a] via-[#18365f] to-[#1b4475] overflow-y-auto z-50 pt-24 pb-12">
    <div class="flex items-start justify-center min-h-full">
      <div class="w-full max-w-md px-4 mt-6">
        <div class="rounded-xl border border-cyan-400/30 bg-slate-900/85 backdrop-blur-sm shadow-xl shadow-black/40 p-8 md:p-10">
          <div class="text-center mb-8">
            <h1 class="text-4xl font-bold text-slate-100">PowerAgent</h1>
            <p class="text-slate-400 mt-2">Acesse sua conta</p>
          </div>

          <form @submit.prevent="handleLogin" class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">Nome do seu Ambiente</label>
              <input
                v-model="form.master_code"
                type="text"
                placeholder="Ex: xpto-locacoes"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">Email</label>
              <input
                v-model="form.email"
                type="email"
                placeholder="seu@email.com"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">Senha</label>
              <div class="relative">
                <input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Sua senha"
                  required
                  autocomplete="current-password"
                  class="w-full pl-3 pr-11 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
                />
                <button
                  type="button"
                  class="absolute inset-y-0 right-0 flex items-center justify-center w-11 text-slate-400 hover:text-[#2AD7DE] focus:outline-none focus-visible:text-[#2AD7DE] rounded-r-lg"
                  :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
                  :aria-pressed="showPassword"
                  @click="showPassword = !showPassword"
                >
                  <svg v-if="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                </button>
              </div>
            </div>

            <div v-if="error" class="bg-red-500/10 border border-red-400/40 text-red-300 px-4 py-3 rounded-lg text-sm">
              {{ error }}
            </div>

            <button
              type="submit"
              :disabled="loading"
              class="w-full bg-[#2AD7DE] hover:bg-[#5de9f0] text-slate-950 py-2.5 rounded-lg font-semibold transition disabled:opacity-50"
            >
              {{ loading ? 'Carregando...' : 'Entrar' }}
            </button>

            <div class="text-center text-sm mt-4">
              <span class="text-slate-400">Não tem uma conta? </span>
              <button type="button" @click="$emit('switch-to-register')" class="text-cyan-300 font-semibold hover:text-cyan-200">
                Criar Conta
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

/** Lembrar o ambiente após logout (igual ao e-mail — `masterCode` é removido no logout). */
const LAST_LOGIN_MASTER_CODE_KEY = 'lastLoginMasterCode'

export default {
  emits: ['login-success', 'switch-to-register'],

  data() {
    const savedMasterCode =
      localStorage.getItem(LAST_LOGIN_MASTER_CODE_KEY) ||
      localStorage.getItem('masterCode') ||
      ''
    const savedEmail = localStorage.getItem('lastLoginEmail') || ''
    return {
      showPassword: false,
      loading: false,
      error: '',
      form: {
        master_code: savedMasterCode,
        email: savedEmail,
        password: ''
      }
    }
  },

  methods: {
    async handleLogin() {
      this.loading = true
      this.error = ''

      try {
        const response = await axios.post('/api/v1/tenants/login', {
          master_code: this.form.master_code,
          email: this.form.email,
          password: this.form.password
        })

        localStorage.setItem('tenantToken', response.data.tenantToken)
        localStorage.setItem('userToken', response.data.userToken)
        localStorage.setItem('tenant', JSON.stringify(response.data.tenant))
        localStorage.setItem('user', JSON.stringify(response.data.user))
        const canonicalCode = String(response.data.tenant.master_code || '').trim().toLowerCase()
        localStorage.setItem('masterCode', response.data.tenant.master_code)
        localStorage.setItem(LAST_LOGIN_MASTER_CODE_KEY, canonicalCode)
        localStorage.setItem('lastLoginEmail', this.form.email.trim())

        this.$emit('login-success', {
          tenant: response.data.tenant,
          user: response.data.user,
          tenantToken: response.data.tenantToken,
          userToken: response.data.userToken
        })
      } catch (err) {
        const data = err.response?.data
        this.error = data?.error || 'Falha no login. Tente novamente.'
        if (data?.rejection_message) {
          this.error += ' ' + data.rejection_message
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
